import type { JSX } from 'react';
/**
 * ページネーションコンポーネント（Quiz/Diagnosis/Form 共通）
 * 前へ/次へ + Showing N-M of K
 */
export default function WsPagination(props: {
  pageNo: number;
  hasNext: boolean;
  pageStartNum: number;
  pageEndNum: number;
  totalCount: number;
  onPrev: () => void;
  onNext: () => void;
}): JSX.Element {
  const { pageNo, hasNext, pageStartNum, pageEndNum, totalCount, onPrev, onNext } = props;

  return (
    <div className="d-flex justify-content-between align-items-center">
      <p className="page-number mb-0">{`Showing ${pageStartNum}-${pageEndNum} of ${totalCount}`}</p>
      <nav aria-label="Page navigation" className="navigation">
        <ul className="pagination mb-0">
          <li className="page-item">
            <a
              onClick={onPrev}
              className={`page-link prev ${pageNo <= 1 && `disabled`}`}
              aria-label="Previous"
            >
              <span aria-hidden="true"></span>
            </a>
          </li>
          <li className="page-item">
            <a
              onClick={onNext}
              className={`page-link next ${!hasNext && `disabled`}`}
              aria-label="Next"
            >
              <span aria-hidden="true"></span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}
